import * as React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { StoreState } from "../../../models/states/StoreState";
import { PageModel } from "../../../models/PageModel";
import LoadingEllipsis from "../shared/LoadingEllipsis";
import useSimulatedPages from "../../../hooks/useSimulatedPages";
import useScrollToActive from "../../../hooks/useScrollToActive";
import FlowPage from "./FlowPage";
import WidgetPanel from "./WidgetPanel";

interface PageProps {
    active?: boolean;
    simulated?: boolean;
    completed?: boolean;
}

export function FlowPanel() {
    const containerRef = React.useRef<HTMLDivElement>(null);
    const history = useSelector((state: StoreState) => state.interview.navigation?.history) || [];
    const currentPage = useSelector((state: StoreState) => state.interview.navigation?.currentPage);
    const { simulatedPages, simulating } = useSimulatedPages();
    const { t } = useTranslation();

    useScrollToActive(containerRef as React.MutableRefObject<Element>);

    let previousPageBlockIndex = -1;
    let pageIndex = -1;
    function renderPages(pages: PageModel[], props: PageProps = {}) {
        let localPageIndex = -1;
        return pages.map((page) => {
            if (!page) return null;
            const showBlockName = previousPageBlockIndex !== page.blockIndex;
            previousPageBlockIndex = page.blockIndex;
            localPageIndex += 1;
            return (
                <FlowPage
                    key={`${props.active ? "active" : props.completed ? "completed" : "simulated"}-${localPageIndex}`}
                    page={page}
                    isFirst={localPageIndex === 0}
                    showBlockName={showBlockName}
                    {...props}
                />
            );
        });
    }

    return (
        <WidgetPanel title={t("debug.panels.flow.title")} containerRef={containerRef}>
            {renderPages(history, { completed: true })}
            {currentPage && renderPages([currentPage], { active: true })}
            {renderPages(simulatedPages, { simulated: true })}
            {currentPage && simulating && (
                <LoadingEllipsis text={t("debug.panels.flow.simulating")} />
            )}
        </WidgetPanel>
    );
}
